module.exports = __webpack_public_path__ + "media/images/usage-coupon-1-53b3d4d292fab6dd094055f138f3214f.png";